import React, { useState } from 'react';
import { HeadphonesIcon, ChevronDownIcon, ChevronUpIcon, ExternalLinkIcon } from 'lucide-react';
export function ListenHelpCard() {
  const [open, setOpen] = useState(false);
  return <section id="listen-help" aria-label="Listen instead of read" className="rounded-lg border border-slate-200 bg-white shadow-sm overflow-hidden" data-id="element-135">
      <div className="p-5 sm:p-6" data-id="element-136">
        <div className="flex items-start gap-3" data-id="element-137">
          <span className="flex-shrink-0 flex items-center justify-center w-9 h-9 rounded-full" style={{
          backgroundColor: '#EDE7F6'
        }} data-id="element-138">
            <HeadphonesIcon className="h-4 w-4" style={{
            color: '#4A2D8F'
          }} data-id="element-139" />
          </span>
          <div className="min-w-0 flex-1" data-id="element-140">
            <h3 className="text-sm font-bold text-slate-800" data-id="element-141">
              Prefer to listen instead of read?
            </h3>

            <div className="mt-2 space-y-2.5" data-id="element-142">
              <p className="text-xs text-slate-600 leading-relaxed" data-id="element-143">
                You may use your device or browser&rsquo;s built-in read-aloud
                tools to listen to page content. Some students also choose a
                third-party text-to-speech tool, such as NaturalReader, for
                additional read-aloud support.
              </p>
              <p className="text-xs text-slate-500 leading-relaxed" data-id="element-144">
                NaturalReader offers free text-to-speech options, but Desert
                Sage does not require a specific tool and does not provide
                support for third-party extensions or apps. Please use whichever
                read-aloud option works best on your device.
              </p>
            </div>

            {/* Compact external link buttons */}
            <div className="mt-3 flex flex-wrap gap-2" data-id="element-145">
              <a href="https://www.naturalreaders.com/online/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-md border transition-colors hover:bg-purple-50" style={{
              borderColor: '#D6CCEF',
              color: '#4A2D8F'
            }} data-id="element-146">
                <ExternalLinkIcon className="h-3.5 w-3.5" data-id="element-147" />
                Open NaturalReader
              </a>
              <a href="https://chromewebstore.google.com/search/NaturalReader%20text%20to%20speech" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-md border transition-colors hover:bg-purple-50" style={{
              borderColor: '#D6CCEF',
              color: '#4A2D8F'
            }} data-id="element-148">
                <ExternalLinkIcon className="h-3.5 w-3.5" data-id="element-149" />
                Find NaturalReader Extension
              </a>
            </div>

            <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} className="inline-flex items-center gap-1 mt-3 text-xs font-semibold transition-colors hover:opacity-80" style={{
            color: '#4A2D8F'
          }} data-id="element-150">
              How to get started
              {open ? <ChevronUpIcon className="h-3.5 w-3.5" data-id="element-151" /> : <ChevronDownIcon className="h-3.5 w-3.5" data-id="element-152" />}
            </button>

            {open && <div className="mt-3 rounded-md bg-slate-50 border border-slate-100 p-3 space-y-2.5" data-id="element-153">
                <div data-id="element-154">
                  <p className="text-xs font-semibold text-slate-700" data-id="element-155">Chrome</p>
                  <p className="text-xs text-slate-600 leading-relaxed" data-id="element-156">
                    Install a text-to-speech browser extension such as
                    NaturalReader, return to the course page or instructions,
                    then use the extension&rsquo;s play controls.
                  </p>
                </div>
                <div data-id="element-157">
                  <p className="text-xs font-semibold text-slate-700" data-id="element-158">
                    iPhone / iPad
                  </p>
                  <p className="text-xs text-slate-600 leading-relaxed" data-id="element-159">
                    Use Apple&rsquo;s built-in Spoken Content or Speak Screen
                    accessibility tools.
                  </p>
                </div>
                <div data-id="element-160">
                  <p className="text-xs font-semibold text-slate-700" data-id="element-161">
                    Android
                  </p>
                  <p className="text-xs text-slate-600 leading-relaxed" data-id="element-162">
                    Use Android&rsquo;s Select to Speak or built-in
                    accessibility read-aloud tools.
                  </p>
                </div>
              </div>}
          </div>
        </div>
      </div>
    </section>;
}